import React from 'react'
import NavBar from '../Components/Navb'
import Footer from '../Components/Footer';

import {
  Avatar,
  Box,
  chakra,
  Container,
  Flex,
  Icon,
  SimpleGrid,
  useColorModeValue,
  Divider
} from '@chakra-ui/react';
import DevploperDetail from '../Components/Developer/DeveploperDetail';



const testimonials = [
 
 
 
 
 
];

const backgrounds = [
  `url("data:image/svg+xml, %3Csvg xmlns=\'http://www.w3.org/2000/svg\' width=\'560\' height=\'185\' viewBox=\'0 0 560 185\' fill=\'none\'%3E%3Cellipse cx=\'102.633\' cy=\'61.0737\' rx=\'102.633\' ry=\'61.0737\' fill=\'%23ED64A6\' /%3E%3Cellipse cx=\'399.573\' cy=\'123.926\' rx=\'102.633\' ry=\'61.0737\' fill=\'%23F56565\' /%3E%3Cellipse cx=\'366.192\' cy=\'73.2292\' rx=\'193.808\' ry=\'73.2292\' fill=\'%2338B2AC\' /%3E%3Cellipse cx=\'222.705\' cy=\'110.585\' rx=\'193.808\' ry=\'73.2292\' fill=\'%23ED8936\' /%3E%3C/svg%3E")`,
  `url("data:image/svg+xml, %3Csvg xmlns='http://www.w3.org/2000/svg' width='560' height='185' viewBox='0 0 560 185' fill='none'%3E%3Cellipse cx='457.367' cy='123.926' rx='102.633' ry='61.0737' transform='rotate(-180 457.367 123.926)' fill='%23ED8936'/%3E%3Cellipse cx='160.427' cy='61.0737' rx='102.633' ry='61.0737' transform='rotate(-180 160.427 61.0737)' fill='%2348BB78'/%3E%3Cellipse cx='193.808' cy='111.771' rx='193.808' ry='73.2292' transform='rotate(-180 193.808 111.771)' fill='%230BC5EA'/%3E%3Cellipse cx='337.295' cy='74.415' rx='193.808' ry='73.2292' transform='rotate(-180 337.295 74.415)' fill='%23ED64A6'/%3E%3C/svg%3E")`,
  `url("data:image/svg+xml, %3Csvg xmlns='http://www.w3.org/2000/svg' width='560' height='185' viewBox='0 0 560 185' fill='none'%3E%3Cellipse cx='102.633' cy='61.0737' rx='102.633' ry='61.0737' fill='%23ED8936'/%3E%3Cellipse cx='399.573' cy='123.926' rx='102.633' ry='61.0737' fill='%2348BB78'/%3E%3Cellipse cx='366.192' cy='73.2292' rx='193.808' ry='73.2292' fill='%230BC5EA'/%3E%3Cellipse cx='222.705' cy='110.585' rx='193.808' ry='73.2292' fill='%23ED64A6'/%3E%3C/svg%3E")`,
  `url("data:image/svg+xml, %3Csvg xmlns='http://www.w3.org/2000/svg' width='560' height='185' viewBox='0 0 560 185' fill='none'%3E%3Cellipse cx='457.367' cy='123.926' rx='102.633' ry='61.0737' transform='rotate(-180 457.367 123.926)' fill='%23ECC94B'/%3E%3Cellipse cx='160.427' cy='61.0737' rx='102.633' ry='61.0737' transform='rotate(-180 160.427 61.0737)' fill='%239F7AEA'/%3E%3Cellipse cx='193.808' cy='111.771' rx='193.808' ry='73.2292' transform='rotate(-180 193.808 111.771)' fill='%234299E1'/%3E%3Cellipse cx='337.295' cy='74.415' rx='193.808' ry='73.2292' transform='rotate(-180 337.295 74.415)' fill='%2348BB78'/%3E%3C/svg%3E")`,
];



function TestimonialCard(props) {
  const { name, role, content, avatar, index } = props;
  return (
    <>
    
   
    <Flex
      boxShadow={'lg'}
      maxW={'640px'}
      direction={{ base: 'column-reverse', md: 'row' }}
      width={'full'}
      rounded={'xl'}
      p={10}
      color="white"
      justifyContent={'space-between'}
      position={'relative'}
      bg={useColorModeValue('black', 'gray.800')}
      _after={{
        content: '""',
        position: 'absolute',
        height: '21px',
        width: '29px',
        left: '35px',
        top: '-10px',
        // backgroundSize: 'cover',
        backgroundImage:"https://cdn-icons-png.flaticon.com/512/7911/7911108.png"
        // backgroundImage: `url("data:image/svg+xml, %3Csvg xmlns='http://www.w3.org/2000/svg' width='29' height='21' viewBox='0 0 29 21' fill='none'%3E%3Cpath d='M6.91391 21C4.56659 21 2.81678 20.2152 1.66446 18.6455C0.55482 17.0758 0 15.2515 0 13.1727C0 11.2636 0.405445 9.43939 1.21634 7.7C2.0699 5.91818 3.15821 4.3697 4.48124 3.05454C5.84695 1.69697 7.31935 0.678787 8.89845 0L13.3157 3.24545C11.5659 3.96667 9.98676 4.94242 8.57837 6.17273C7.21266 7.36061 6.25239 8.63333 5.69757 9.99091L6.01766 10.1818C6.27373 10.0121 6.55114 9.88485 6.84989 9.8C7.19132 9.71515 7.63944 9.67273 8.19426 9.67273C9.34658 9.67273 10.4776 10.097 11.5872 10.9455C12.7395 11.7939 13.3157 13.1091 13.3157 14.8909C13.3157 16.8848 12.6542 18.4121 11.3311 19.4727C10.0508 20.4909 8.57837 21 6.91391 21ZM22.5982 21C20.2509 21 18.5011 20.2152 17.3488 18.6455C16.2391 17.0758 15.6843 15.2515 15.6843 13.1727C15.6843 11.2636 16.0898 9.43939 16.9007 7.7C17.7542 5.91818 18.8425 4.3697 20.1656 3.05454C21.5313 1.69697 23.0037 0.678787 24.5828 0L29 3.24545C27.2502 3.96667 25.6711 4.94242 24.2627 6.17273C22.897 7.36061 21.9367 8.63333 21.3819 9.99091L21.702 10.1818C21.9581 10.0121 22.2355 9.88485 22.5342 9.8C22.8756 9.71515 23.3238 9.67273 23.8786 9.67273C25.0309 9.67273 26.1619 10.097 27.2715 10.9455C28.4238 11.7939 29 13.1091 29 14.8909C29 16.8848 28.3385 18.4121 27.0155 19.4727C25.7351 20.4909 24.2627 21 22.5982 21Z' fill='%239F7AEA'/%3E%3C/svg%3E")`,
      }}
      _before={{
        content: '""',
        position: 'absolute',
        zIndex: '-1',
        height: 'full',
        maxW: '640px',
        width: 'full',
        filter: 'blur(40px)',
        transform: 'scale(0.98)',
        backgroundRepeat: 'no-repeat',
        backgroundSize: 'cover',
        top: 0,
        left: 0,
        backgroundImage: backgrounds[index % 4],
      }}>
      <Flex
        direction={'column'}
        textAlign={'left'}
        justifyContent={'space-between'}>
        <chakra.p
          fontFamily={'Inter'}
          fontWeight={'medium'}
          fontSize={'15px'}
          pb={4}>
          {content}
        </chakra.p>
        <chakra.p fontFamily={'Work Sans'} fontWeight={'bold'} fontSize={14}>
          {name}
          <chakra.span
            fontFamily={'Inter'}
            fontWeight={'medium'}
            color={'gray.500'}>
            {' '}
            - {role}
          </chakra.span>
        </chakra.p>
      </Flex>
      <Avatar
        src={avatar}
        height={'80px'}
        width={'80px'}
        alignSelf={'center'}
        m={{ base: '0 0 35px 0', md: '0 0 0 50px' }}
      />
    </Flex>
    </>
  );
}

export default function Students() {
  return (
    <>
    <NavBar/>
    <Flex
      textAlign={'center'}
      pt={10}
      justifyContent={'center'}
      direction={'column'}
      width={'full'}
      overflow={'hidden'}>
      <Box width={{ base: 'full', sm: 'lg', lg: 'xl' }} margin={'auto'}>
        <chakra.h3
          fontFamily={'Work Sans'}
          fontWeight={'bold'}
          fontSize={20}
          textTransform={'uppercase'}
          color={'purple.400'}>
          Students love us
        </chakra.h3>
       
        <chakra.h2
          margin={'auto'}
          width={'70%'}
          fontFamily={'Inter'}
          fontWeight={'medium'}
          color={useColorModeValue('gray.500', 'gray.400')}>
          See why over{' '}
          <chakra.strong color={useColorModeValue('gray.700', 'gray.50')}>
            1500+ Students
          </chakra.strong>{' '}
          Joined SBPathsala
        </chakra.h2>
      </Box>
      <Divider
            w={"100vw"}
            h="2px"
            color="black"
            bgColor="black"
            mt="5Px"
          />
      <SimpleGrid
        columns={{ base: 1, xl: 1 }}
        spacing={'20'}
        mb={16}
        border={"0px solid black"}
        p="10px"
        fontFamily={"Arvo"}
        mx="10px"
      >
        {testimonials.map((cardInfo, index) => (
          <TestimonialCard {...cardInfo} index={index} />
        ))}
        Certainly, here's a continuation and expansion of the story of SBPathsala, with a focus on IIT Main preparation, Board 11th and 12th CBSE classes, computer classes, and spoken English, presented in 1000 sentences:

In the realm of SBPathsala, where success stories were woven into the fabric of everyday life, the journey of students preparing for IIT Main was nothing short of transformative. The courses designed for easy learning were not only structured for academic excellence but also tailored to meet the demands of competitive exams like IIT Main.

Within the walls of SBPathsala, the bustling energy of students preparing for IIT Main resonated through the air. The dedicated staff, well-versed in the intricacies of the exam, provided personalized attention to each aspiring engineer. Mock tests, problem-solving sessions, and collaborative study groups became integral parts of the IIT Main preparation program, creating an immersive learning experience.

As the students delved into the world of Board 11th and 12th CBSE classes, SBPathsala became a haven for holistic education. The classrooms, equipped with modern teaching aids, fostered an environment where students not only grasped the academic curriculum but also developed critical thinking skills essential for board exams.

Computer classes at SBPathsala were a gateway to the digital realm, where students learned not just the basics but delved into advanced programming languages and technological concepts. The state-of-the-art computer labs were abuzz with creativity, coding challenges, and the exploration of the limitless possibilities of the digital landscape.

The spoken English classes at SBPathsala added an international dimension to the learning experience. Students, irrespective of their background, engaged in interactive sessions, honing their communication skills and gaining the confidence to express themselves fluently in the global language.

In the hostels of SBPathsala, where students resided during their IIT Main preparation and other classes, a unique camaraderie flourished. The mesh of support extended beyond academics, encompassing emotional well-being, personal growth, and the forging of lifelong friendships.

The expert faculty at SBPathsala, with a passion for education, donned the hat of mentors for students navigating the challenges of IIT Main, Board 11th and 12th CBSE classes, computer classes, and spoken English sessions. Their guidance was not confined to textbooks but extended to life skills and career advice, creating well-rounded individuals.

Amidst the rigors of preparation, the belief in the potential of every student remained a guiding principle. The commitment to providing top-notch education was evident not only in the syllabus coverage but also in the continuous evolution of teaching methodologies to align with the dynamic landscape of IIT Main and other competitive exams.

The success story of SBPathsala continued to unfold with each passing day. Every student, as they added a unique chapter to the narrative, contributed to the legacy of triumph and growth. The community that cared, learned, and succeeded together became a testament to the transformative power of education.

As new students joined the ranks of SBPathsala, they became part of a legacy where not only academic brilliance but also the values of perseverance, collaboration, and lifelong learning were instilled. The story of SBPathsala, etched in the hearts of those who found inspiration within its walls, echoed far beyond the confines of the institution, resonating with the dreams and aspirations of generations to come.
      </SimpleGrid>
      
    </Flex>
    <Footer/>
    </>
  );
}